export const types = {
  LOCATION_CHANGED: 'ROUTER/LOCATION_CHANGED',
  LOCATION_CLEANUP: 'ROUTER/LOCATION_CLEANUP',
  LOCATION_INIT: 'ROUTER/LOCATION_INIT'
};
